module.exports = __webpack_public_path__ + "static/media/-5.92ad9c93.png";